export default "__VITE_ASSET__BeX7UFYx__"